
import * as Li9za2lrby5tanM from './skiko.mjs';
import * as _ref_QGpzLWpvZGEvY29yZQ_ from '@js-joda/core';
import * as _ref_ZmlyZWJhc2UvYW5hbHl0aWNz_ from 'firebase/analytics';
import * as _ref_ZmlyZWJhc2UvYXBw_ from 'firebase/app';
import * as _ref_ZmlyZWJhc2UvYXV0aA_ from 'firebase/auth';
import * as _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_ from 'firebase/firestore';
import * as _ref_ZmlyZWJhc2UvZnVuY3Rpb25z_ from 'firebase/functions';
import * as _ref_ZmlyZWJhc2UvcGVyZm9ybWFuY2U_ from 'firebase/performance';
import * as _ref_ZmlyZWJhc2Uvc3RvcmFnZQ_ from 'firebase/storage';
import { instantiate } from './aidyn_ai-composeApp.uninstantiated.mjs';


const exports = (await instantiate({
    './skiko.mjs': Li9za2lrby5tanM,
    '@js-joda/core': _ref_QGpzLWpvZGEvY29yZQ_,
    'firebase/analytics': _ref_ZmlyZWJhc2UvYW5hbHl0aWNz_,
    'firebase/app': _ref_ZmlyZWJhc2UvYXBw_,
    'firebase/auth': _ref_ZmlyZWJhc2UvYXV0aA_,
    'firebase/firestore': _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_,
    'firebase/functions': _ref_ZmlyZWJhc2UvZnVuY3Rpb25z_,
    'firebase/performance': _ref_ZmlyZWJhc2UvcGVyZm9ybWFuY2U_,
    'firebase/storage': _ref_ZmlyZWJhc2Uvc3RvcmFnZQ_
})).exports;

export const {
memory,
_initialize
} = exports


